export default __webpack_public_path__ + "media/images/images/gallery/25-ea2e64975b64f166fa7454c768cdc508.jpg";